import { logisticsActivityLogFragment } from "@saleor/fragments/logisticsActivityLog";
import { shippingZoneActivityLogFragment } from "@saleor/fragments/shippingZoneActivityLog";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  LogisticsActivityLogs,
  LogisticsActivityLogsVariables
} from "./types/LogisticsActivityLogs";
import {
  ShippingZoneActivityLogs,
  ShippingZoneActivityLogsVariables
} from "./types/ShippingZoneActivityLogs";

export const shippingZoneActivityLogs = gql`
  ${shippingZoneActivityLogFragment}
  query ShippingZoneActivityLogs(
    $first: Int
    $before: String
    $after: String
    $last: Int
    $type: String
    $subject: String
    $sortBy: ActivityLogSortingInput
  ) {
    shippingZoneActivityLogs(
      first: $first
      before: $before
      after: $after
      last: $last
      filter: { type: $type, subject: $subject }
      sortBy: $sortBy
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          ...ShippingZoneActivityLogFragment
        }
      }
    }
  }
`;
export const useShippingZoneActivityLogs = makeQuery<
  ShippingZoneActivityLogs,
  ShippingZoneActivityLogsVariables
>(shippingZoneActivityLogs);

export const logisticsActivityLogs = gql`
  ${logisticsActivityLogFragment}
  query LogisticsActivityLogs(
    $first: Int
    $before: String
    $after: String
    $last: Int
    $type: StoreTypeEnum
    $subject: String
    $sortBy: ActivityLogSortingInput
    $format: ActivityLogFormatEnum
    $malls: [ID]
  ) {
    logisticsActivityLogs(
      first: $first
      before: $before
      after: $after
      last: $last
      filter: { type: $type, subject: $subject, format: $format, malls: $malls }
      sortBy: $sortBy
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          ...LogisticsActivityLogFragment
        }
      }
    }
  }
`;
export const useLogisticsActivityLogs = makeQuery<
  LogisticsActivityLogs,
  LogisticsActivityLogsVariables
>(logisticsActivityLogs);
